import { WalletModalProvider } from './components/WalletModalContext';
import ConnectWalletModal from './components/ConnectWalletModal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import EveryAction from './components/EveryAction';
import TheComeback from './components/TheComeback';
import StepsSection from './components/StepsSection';
import TheSteps from './components/TheSteps';
import HowItWorks from './components/HowItWorks';
import WhyDoppler from './components/WhyDoppler';
import BackedBy from './components/BackedBy';
import LatestFromDoppler from './components/LatestFromDoppler';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';
import './styles/global.css';

export default function App() {
  return (
    <WalletModalProvider>
      <Navbar />
      <main>
        <Hero zIndex={1} />
        <EveryAction zIndex={2} />
        <TheComeback zIndex={3} />
        <StepsSection zIndex={4} />
        <TheSteps zIndex={5} />
        <HowItWorks zIndex={6} />
        <WhyDoppler zIndex={7} />
        <BackedBy zIndex={8} />
        <LatestFromDoppler zIndex={9} />
        <FaqSection zIndex={10} />
        <Footer zIndex={11} />
      </main>
      <ConnectWalletModal />
    </WalletModalProvider>
  );
}